import { RootState } from '../../store/store';

export const selectOrderDetails = (state: RootState) => state.order.order;
export const getPaymentMethodsSelector = (state: RootState) =>
  state.order.paymentMethods;
export const getSelectedId = (state: RootState) => state.order.selectedId;
export const getPaymentMethodsStatus = (state: RootState) =>
  state.order.paymentMethodsStatus;
export const getPaymentMethodsError = (state: RootState) =>
  state.order.paymentMethodsError;
